import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import * as AnalyticsActions from '../../redux/analytics/actions';
import { useDispatch } from 'react-redux';
import Spinner from 'react-spinkit';
import get from 'lodash/get';
import { Link } from 'react-router-dom';

function AnalyticsEditPage(props) {
  const history = useHistory();
  const dispatch = useDispatch();
  const [editingEvent, setEditingEvent] = useState(get(props, 'location.state.event', 7));
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const handleInternalDescriptionChange = (event) => {
    setEditingEvent({
      ...editingEvent,
      internal_description: event.target.value
    });
  };

  const handleSave = (event) => {
    event.preventDefault();
    setError(null);
    setLoading(true);
    dispatch(AnalyticsActions.editEvent(editingEvent,
      () => {
        setLoading(false);
        history.push(`../dashboard/users`);
        // history.goBack()
      },
      (error) => {
        setError(error);
        setLoading(false);
        setError(error);
      }));
  };

  return (
    <div
      style={{ width: '100%' }}
    >
      {
        loading &&
        <div>
          <Spinner name="circle" className="spinner" fadeIn="quarter" color="#3897dc"/>
          <div className="overlay">
          </div>
        </div>
      }
      {
        editingEvent ? (
          <div className="card mx-auto">
            <div className="card-header">Редактирование события id {editingEvent.id}</div>
            <div className="card-body">
              <form onSubmit={handleSave}>
                <div className="form-group">
                  <div className="form-label-group">
                    <p>
                      Событие: {editingEvent.event_name}
                    </p>
                    <p>
                      Автор:
                      {
                        editingEvent.emitter_user &&
                        <Link
                          className="nav-link"
                          to={{
                            pathname: '/dashboard/users/' + editingEvent.emitter_user.id + '/edit',
                          }}
                          key={editingEvent.emitter_user.id}
                        >
                          {editingEvent.emitter_user.display_name}
                        </Link>
                      }
                    </p>
                    <p>
                      Связанный:
                      {
                        editingEvent.linked_user &&
                        <Link
                          className="nav-link"
                          to={{
                            pathname: '/dashboard/users/' + editingEvent.linked_user.id + '/edit',
                            state: {
                              user: editingEvent.linked_user
                            }
                          }}
                          key={editingEvent.linked_user.id}
                        >
                          {editingEvent.linked_user.display_name}
                        </Link>
                      }
                    </p>
                    <p>
                      Дата: {editingEvent.inserted_at}
                    </p>
                  </div>
                </div>
                <div className="form-group">
                  <label htmlFor="inputInternalDescription">Внутренний комментарий</label>
                  <div className="form-label-group">
                      <textarea
                        id="inputInternalDescription"
                        className="form-control"
                        value={editingEvent.internal_description || ''}
                        onChange={handleInternalDescriptionChange}
                      />
                  </div>
                </div>
                {
                  error &&
                  <div className="form-group">
                    <div className="alert alert-danger">
                      <strong>Ошибка!</strong> {error}
                    </div>
                  </div>
                }
                <button className="btn btn-primary btn-block" type="submit">Сохранить</button>
              </form>
            </div>
          </div>
        ) : (
          <div className="alert alert-danger">
            <strong>Ошибка!</strong> событие не найдено
          </div>
        )
      }
    </div>
  );
}

export default AnalyticsEditPage;



// WEBPACK FOOTER //
// ./src/pages/AnalyticsEditPage/index.jsx